import { render, staticRenderFns } from "./projectCaseDetails.vue?vue&type=template&id=2233e59e&scoped=true&"
import script from "./projectCaseDetails.vue?vue&type=script&lang=js&"
export * from "./projectCaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./projectCaseDetails.vue?vue&type=style&index=0&id=2233e59e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2233e59e",
  null
  
)

export default component.exports